import { useMutation, useQueryClient } from "react-query";
import {
  EducationalPromotionData,
  studyCenterService,
} from "@services/study-center";
import { studyCenterQueryKeys } from "./queryKeys";

export const useCreateEducationalPromotionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (data: EducationalPromotionData) =>
      studyCenterService.createPromotion(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(studyCenterQueryKeys.all);
      },
    }
  );
};
